import clsx from 'clsx';
import { AttendanceStatus, AttendanceStatusLabelMap } from '@airreading/common/data';
import { Badge } from '@/components/ui/badge.js';

interface AttendanceStatusBadgeProps {
  attendanceStatus: AttendanceStatus;
}

const AttendanceStatusColorMap: Record<AttendanceStatus, string> = {
  [AttendanceStatus.at_risk]: 'bg-[#FEF3C7] hover:bg-[#FEF3C7] text-[#A16207]',
  [AttendanceStatus.triggered]: 'bg-[#FFEDD5] hover:bg-[#FFEDD5] text-[#EA580C]',
  [AttendanceStatus.reassigned]: 'bg-[#FFE4E6] hover:bg-[#FFE4E6] text-[#DC2626]',
};

export const AttendanceStatusBadge = ({ attendanceStatus }: AttendanceStatusBadgeProps) => {
  return (
    <Badge
      className={clsx(
        'p-1 rounded-[6px] text-[14px] text-center font-bold',
        AttendanceStatusColorMap[attendanceStatus],
      )}
    >
      {AttendanceStatusLabelMap[attendanceStatus]}
    </Badge>
  );
};
